import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SearchProduct = createAsyncThunk(
  "searchData/searchProduct",
  async (name, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.SearchProduct}?name=${name}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SearchProductSlice = createSlice({
  name: "SeachProductData",
  initialState: {
    SeachProductData: [],
    error: null,
  },
  reducers: {
    clearSeachProductData: (state) => {
      state.SeachProductData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SearchProduct.fulfilled, (state, action) => {
        state.SeachProductData = action.payload;
      })
      .addCase(SearchProduct.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});
export const { clearSeachProductData } = SearchProductSlice.actions;
export default SearchProductSlice.reducer;
